module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event4/younite-event-ko-0fd092d9969ff6e2feb989d0d581e94d.png";